/*
 * Do not remove or alter the notices in this preamble.
 * This software code regards iO Custom Software.
 * Copyright © 2026 iO The Netherlands B.V. and/or its affiliates.
 * www.iodigital.com All rights reserved. License grant and user rights and obligations
 * according to applicable license agreement. Please contact legal@iodigital.com for
 * questions regarding license and user rights.
 */

import { consume } from '@lit/context';
import { css, html, LitElement } from 'lit';
import { customElement } from 'lit/decorators.js';

import { ConfiguratorContextType, configuratorGlobal } from '@/context';
import { baseStyles, skeletonStyles } from '@/styles';
import { classMap } from 'lit/directives/class-map.js';

@customElement('fg-quantity-step-skeleton-loader')
export class FgQuantityStepSkeletonLoader extends LitElement {
  @consume({ context: configuratorGlobal.context, subscribe: true })
  configuratorContext!: ConfiguratorContextType;

  isNotCollapsible() {
    return this.configuratorContext.quantityCollapsible !== 1;
  }

  render() {
    const collapsibleModifier = {
      'is-not-collapsible': this.isNotCollapsible(),
    };

    return html`
      <div class="skeleton-container ${classMap(collapsibleModifier)}">
        ${this.isNotCollapsible()
          ? html`
              <div class="skeleton-header">
                <div class="skeleton-title-main"></div>
                <div class="skeleton-subtitle"></div>
              </div>
              <div class="skeleton-content">
                <div class="skeleton-block"></div>
              </div>
              <div class="skeleton-footer-text"></div>
            `
          : html`
              <div class="skeleton-header">
                <div class="skeleton-title"></div>
                <div class="skeleton-icon"></div>
              </div>
            `}
      </div>
    `;
  }

  static styles = [
    baseStyles,
    skeletonStyles,
    css`
      .skeleton-container.is-not-collapsible .skeleton-header {
        flex-direction: column;
        align-items: flex-start;
        gap: 0.75rem;
        margin-bottom: var(--skeleton-gap-default);
      }

      .skeleton-title-main {
        background: var(--skeleton-gray);
        border-radius: var(--skeleton-border-radius);
        height: 1.5rem;
        width: 12rem;
      }

      .skeleton-subtitle {
        background: var(--skeleton-gray);
        border-radius: var(--skeleton-border-radius);
        height: 1rem;
        width: 20rem;
        opacity: 0.7;
      }

      .skeleton-content {
        display: none;
      }

      .skeleton-container.is-not-collapsible .skeleton-content {
        display: block;
        margin-bottom: var(--skeleton-gap-default);
      }

      .skeleton-block {
        height: 12rem;
      }

      .skeleton-footer-text {
        display: none;
      }

      .skeleton-container.is-not-collapsible .skeleton-footer-text {
        display: block;
        background: var(--skeleton-gray);
        border-radius: var(--skeleton-border-radius);
        height: 0.875rem;
        width: 18rem;
        opacity: 0.6;
        margin-top: var(--skeleton-gap-default);
      }
    `,
  ];
}
